import api from "./interceptors"; // Pakai instance API yang sudah ada

const userDetail = async () => {
  return await api.post("detail-user");
};

const logout = async (userid, device) => {
  let data = new FormData();
  data.append("user_id", userid);
  data.append("device_info", device);
  return await api.post("logout-account", data);
};

const register = async (data) => {
  let req = new FormData();
  req.append("email", data.email);
  req.append("name", data.fullName);
  req.append("usr_birthdate", data.usr_birthDate);
  req.append("phone", data.phoneNumber);
  req.append("gender", data.gender);
  req.append("no_mr", data.patientMRNumber);
  req.append("relationship", data.relationshipStatus);
  req.append("psn_birthdate", data.psn_birthDate);
  req.append("password_access", data.password);
  if (data.referralCode) {
    req.append("referral_code", data.referralCode);
  }

  return await api.post("register", req);
};

const editUser = async (req) => {
  let data = new FormData();
  // FormData mengubah null menjadi teks "null" — akun tanpa email (akun wali) dulu
  // tersimpan dengan email "null", lalu akun berikutnya bentrok dengan indeks unik.
  data.append("user_id", req.user_id);
  data.append("name", req.name ?? "");
  data.append("date_of_birth", req.date_of_birth ?? "");
  data.append("email", req.email ?? "");
  data.append("phone", req.phone ?? "");
  data.append("gender", req.gender ?? "");
  return await api.post("edit-account-user", data);
};

const generateOtp = async (phone, device_id) => {
  let data = new FormData();
  data.append("phone", phone);
  data.append("device_id", device_id);
  return await api.post("generate-otp", data);
};

const receiveOtp = async (phone, device_id, otp_code) => {
  let data = new FormData();
  data.append("phone", phone);
  data.append("device_id", device_id);
  data.append("otp_code", otp_code);
  return await api.post("receive-otp", data);
};

const storeFcmToken = async (user_id, fcm_token, device_id) => {
  let data = new FormData();
  data.append("user_id", user_id);
  data.append("fcm_token", fcm_token);
  data.append("device_info", device_id);
  return await api.post("store-fcm-token", data);
};

export default {
  userDetail,
  logout,
  register,
  editUser,
  generateOtp,
  receiveOtp,
  storeFcmToken,
};
